export const NETWORKING_SESSIONS_PARTICIPANT_COUNT_UPDATED = (networkingSessionId: string) => ({
  eventType: 'networking-sessions-participant-count-updated',
  channelName: `networking-sessions-${networkingSessionId}`,
});
